module.exports = __webpack_public_path__ + "media/images/flags/ni-ca665413123c772764a1bcd5cb2d5438.svg";